module.exports = __webpack_public_path__ + "static/media/telenor.4c122006.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/telenor.png
// module id = 5753
// module chunks = 0